import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {UserComponent} from "./pages/user.component";
import {UserFormComponent} from "./pages/user-form/user-form.component";

const routes: Routes = [
  {
    path: '',
    component: UserComponent
  },
  {
    path: 'create',
    component: UserFormComponent
  },
  {
    path: 'update/:id',
    component: UserFormComponent
  },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class UserRoutingModule {
}
